import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import BudgetService, { BUDGET_OVERALL_ID } from 'src/services/budget.service';
import FormatService from 'src/services/format.service';
import React from 'react';
import { useBudget } from 'src/hooks/queries/budgets';
import { useFormikContext } from 'formik';
import { BudgetCreateFormValuesModel } from 'src/types/form-models/budget-create-form-values.model';
import styles from './personalizeCategoryHeader.module.scss';
import Selectors from 'src/utils/selectors';

export default function PersonalizeCategoryHeader(): JSX.Element {
    const { isLoading: isLoadingTargetMonthlySpending, data: targetMonthlySpending } = useBudget(BUDGET_OVERALL_ID);
    const { values } = useFormikContext<BudgetCreateFormValuesModel>();

    const parentCategoryTotal: number = BudgetService.getAllParentCategoriesTotal(values.budgets);

    if (isLoadingTargetMonthlySpending) return null;
    return (
        <div className={styles.personalizeCategoryHeader} data-cy={Selectors.SpendSmart.PERSONALIZE_CATEGORY_HEADER}>
            <Typography variant={TypographyVariants.HEADING_S} className={styles.headerTitle} component="h2">
                {LiteralsService.getLiteral('Budget.Create.cardTitle')}
            </Typography>
            <div className={styles.right}>
                {targetMonthlySpending.monthlyAmount && (
                    <Typography
                        variant={TypographyVariants.SUBTEXT}
                        className={styles.budgetSpendingTitle}
                        component="h2"
                        data-cy={Selectors.SpendSmart.TARGET_MONTHLY_SPENDING}
                    >
                        {LiteralsService.getLiteral('Budget.Create.personalizeCategoryHeader.targetMonthlySpending')}:{' '}
                        <Typography variant={TypographyVariants.HEADING_XS} component="span">
                            {FormatService.format(targetMonthlySpending.monthlyAmount)}
                        </Typography>
                    </Typography>
                )}
                <Typography
                    variant={TypographyVariants.SUBTEXT}
                    className={styles.budgetSpendingTitle}
                    component="h2"
                    data-cy={Selectors.SpendSmart.CATEGORY_BASED_SPENDING}
                >
                    {LiteralsService.getLiteral('Budget.Create.personalizeCategoryHeader.totalBudgetForCategories')}:{' '}
                    <Typography variant={TypographyVariants.HEADING_XS} component="span">
                        {FormatService.format(parentCategoryTotal)}
                    </Typography>
                </Typography>
            </div>
        </div>
    );
}
